export const ROUTE_LOCALES = ['pt', 'en', 'es'] as const

export type RouteLocale = (typeof ROUTE_LOCALES)[number]

export const DEFAULT_ROUTE_LOCALE: RouteLocale = 'en'

/**
 * Normalizes locale-ish strings (pt, pt-BR, pt_BR, es-ES, en-US, ...) to one
 * of the app's supported route locales, or null when unrecognized.
 */
export function normalizeRouteLocale(input?: string | null): RouteLocale | null {
  if (!input) return null
  const primary = input.trim().toLowerCase().split(/[-_]/)[0]
  return (ROUTE_LOCALES as readonly string[]).includes(primary)
    ? (primary as RouteLocale)
    : null
}

/**
 * Resolves the route locale to use from an ordered list of candidates
 * (highest priority first). Callers pass their own priority order (e.g.
 * URL locale, user locale, ?lang=, geo locale) instead of duplicating the
 * normalization rules.
 */
export function resolveRouteLocale(
  candidates: Array<string | null | undefined>,
  fallback: RouteLocale = DEFAULT_ROUTE_LOCALE,
): RouteLocale {
  for (const candidate of candidates) {
    const normalized = normalizeRouteLocale(candidate)
    if (normalized) return normalized
  }
  return fallback
}
